import AppTooltip from '../../components/AppTooltip/AppTooltip.vue'

export default {
    name: 'app-marker',
    components: {
        AppTooltip
    },
    props: ['marker'],
    methods: {
        changeSelectedVideo(vid) {
            this.$store.commit('changeVideo', vid)
        }
    }
}
